import { QuestionTypeName } from '../LearnwareEnums';
export class LearnwareQuestiontypes {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get learnware() {
        return this.parent;
    }
    questiontypeData = [
        { id: QuestionTypeName.MultipleChoice, name: 'Multiple Choice' },
        { id: QuestionTypeName.CorrectWrong, name: 'Richtig / Falsch' },
        { id: QuestionTypeName.KnowAWord, name: 'Ein Begriff wissen' },
        { id: QuestionTypeName.Associate, name: 'Bilder / Texte zuordnen' },
        { id: QuestionTypeName.MemorizePoints, name: 'Mehrere Punkte wissen' },
        { id: QuestionTypeName.ThinkAndReveal, name: 'Karteikarte' },
        { id: QuestionTypeName.OrderedChoice, name: 'Auswahl in Reihenfolge' },
        { id: QuestionTypeName.Vocabulary, name: 'Vokabel' },
        { id: QuestionTypeName.Read, name: 'Lesen' },
        { id: QuestionTypeName.Sortable, name: 'Sortieren' },
        { id: QuestionTypeName.CycleEnd, name: 'Belohnung' },
        { id: QuestionTypeName.Intro, name: 'Intro' },
        { id: QuestionTypeName.Talk, name: 'Gespräch' },
        { id: QuestionTypeName.MultiSelect, name: 'Multi Auswahl' },
    ];
    qtdataById(qtn) {
        return this.questiontypeData.find((qtd) => qtd.id === qtn);
    }
}
